import { render } from "./ConfigWorkSpaceView.vue?vue&type=template&id=7c1abb95"
import script from "./ConfigWorkSpaceView.vue?vue&type=script&lang=js"
export * from "./ConfigWorkSpaceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__